import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const quick = [
  { to: "/about", label: "About Us" },
  { to: "/shop", label: "Shop" },
  { to: "/blog", label: "Blog" },
  { to: "/partners", label: "Our Partners" },
  { to: "/grant-appreciation", label: "Grant Appreciation" },
  { to: "/book", label: "Book Appointment" },
  { to: "/request-service", label: "Request Service" },
];

export function Footer() {
  return (
    <footer className="bg-[#EAE0F2] text-[#2D2336] border-t border-[#D6C6E4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={LOGO_URL} alt="Utopia Dental Care" className="h-16 w-auto" />
          <p className="mt-4 text-sm leading-relaxed text-[#5C5166]">
            Convenient, trusted dental care serving Albuquerque and the underserved
            communities of New Mexico.
          </p>
        </div>

        <div className="space-y-2 text-sm">
          <h4 className="font-serif text-lg text-[#6B4C8A] mb-3">Explore</h4>
          {quick.map((q) => (
            <Link key={q.to} to={q.to} className="block text-[#5C5166] hover:text-[#6B4C8A] transition-colors">
              {q.label}
            </Link>
          ))}
        </div>

        <div className="space-y-3 text-sm">
          <h4 className="font-serif text-lg text-[#6B4C8A] mb-3">Visit Us</h4>
          <p className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#6B4C8A]" /> 6300 Montaño Rd NW, Albuquerque, NM 87120</p>
          <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#6B4C8A]" /> <a href="tel:5053633435" className="hover:text-[#6B4C8A]">505-363-3435</a></p>
          <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#6B4C8A]" /> <a href="mailto:utopiadentalcare@gmail.com" className="hover:text-[#6B4C8A]">utopiadentalcare@gmail.com</a></p>
          <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#6B4C8A]" /> By appointment only</p>
        </div>

        <div className="space-y-3 text-sm">
          <h4 className="font-serif text-lg text-[#6B4C8A] mb-3">Utopia Mobile Care</h4>
          <p className="text-[#5C5166] leading-relaxed">
            A 501(c)(3) nonprofit expanding mobile dental units to treat the
            underserved pediatric and elderly population of New Mexico.
          </p>
        </div>
      </div>
      <div className="border-t border-[#D6C6E4] py-6 text-center text-xs text-[#78698A]">
        © {new Date().getFullYear()} Utopia Dental Care, LLC. All rights reserved.
      </div>
    </footer>
  );
}
